"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../utils/core"));

var _jquery = _interopRequireDefault(require("../utils/jquery.webf"));

var _jquery2 = _interopRequireDefault(require("jquery"));

/**
 * options :
 *  - value
 *  - max
 *  - onCreate
 *  - onComplete
 *
 * Méthodes publiques :
 *  - value
 *  - widget
 */
(0, _jquery["default"])('progressbar', {
  options: {
    value: 0,
    max: 100,
    onCreate: _core["default"].noop,
    onComplete: _core["default"].noop
  },
  _create: function _create() {
    this.e.addClass('webf-progressbar');
    this.e.append((0, _jquery2["default"])('<div>').addClass('inner-progress'));
    this.value(this.option('value'));

    this._call(this.option('onCreate'));
  },
  _refresh: function _refresh() {
    var porcentage = this.value() / this.option('max') * 100;
    this.e.children('.inner-progress').css('width', porcentage + "%");

    if (porcentage >= 100) {
      this._call(this.option('onComplete'));
    }
  },
  value: function value(val) {
    if (_core["default"].isUndefined(val)) {
      return this.val;
    }

    if (!_core["default"].isFloat(val)) {
      val = 0;
    }

    this.val = _core["default"].between(val, 0, this.option('max'));

    this._refresh();
  },
  widget: function widget() {
    return this.$progressBar;
  },
  _destroy: function _destroy() {
    this.e.removeClass('webf-progressbar');
  }
});